import React from 'react';
import ReactDom from "react-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';


function EducationPage() {
  AOS.init();
  return <div id="EducationPage" className="education-page-section">

    <h1 className="education-title title-heading"> Education </h1><hr className="title-hr"/>
    <div className="education-upenn">
        <div className="education-heading">
          <div className="upenn-icon">
            {/* TODO: Add UPenn logo image */}
            <img className="upenn-logo" src={`${process.env.PUBLIC_URL}/images/upenn.png`} alt="University of Pennsylvania" />
          </div>
          <div className="upenn-heading">
            <h2 className="title-heading2"> University of Pennsylvania </h2>
            <h3 className="degree-subheader"> MSE Computer & Information Science </h3>
            <p> August 2025 - May 2027 (Expected) </p>

          </div>
          <div className="education-classes">
            <p> Relevant Courses (Systems): <em> Internet & Web Systems, Operating Systems Design and Implementation, Software Systems</em></p>
            <p> Relevant Courses (AI/ML): <em> Deep Learning for Time Series, Applied Machine Learning, Adv. ML: Learning in Games (And Games in Learning)</em></p>
          </div>

        </div>
        {/* <hr className="title-hr"/>
        <div className="pomona-info">
          <p> My experience so far at Pomona College has been outstanding. As it was my first time being away from home, my time at Pomona truly helped me gain a sense of independence and the motivation to pursue my interests. From my time studying for finals to playing in the Regional Finals for the Pomona-Pitzer baseball team, my college experience allowed me to grow as a person. I learned that the most important thing in life is to prioritize mental health--something I strive for everyday.
          </p>
        </div> */}
    </div>
    <div className="education-pomona">
      <div className="education-heading">
        <div className="pom-icon">
          <img className="pomona-logo" src={`${process.env.PUBLIC_URL}/images/pomonacollegelogo.jpg`} alt="Pomona College" />
        </div>
        <div className="pomona-heading">
          <h2 className="title-heading2"> Pomona College </h2>
          <h3 className="degree-subheader"> Bachelor of Arts </h3>
          <p> August 2021 - May 2025 </p>
        </div>
        <div className="education-classes">
          <p> Relevant Courses (Math): <em> Probability, Combinatorics, Principles of Real Analysis, Stat Theory, Computational Stats, Quantum Computing, Calc III, Lin. Algebra, Discrete Math</em></p>
          <p> Relevant Courses (CS): <em> Algorithms, Machine Learning, Introduction to Databases, Computer Systems, Intro to Languages and Theory, Data Structures & Adv. Programming</em></p>
        </div>
      </div>
      {/* <hr className="title-hr"/>
        <div className="bellarmine-info">
          <p> I was able to study abroad at the University of Edinburgh during my Fall 2023 semester.  </p>
        </div> */}
    </div>


  </div>
}

export default EducationPage;
